exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".profile {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background: #dbdbdb;\n  padding: 0;\n  margin: 5px auto;\n  overflow: hidden; }\n  .profile img {\n    width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/form/form/commerce-social-networks-form/commerce-social-networks-form.component.scss
// module id = 932
// module chunks = 0